<template>
    <vPartnerComponent :postList="postList" v-if="flag"></vPartnerComponent>
</template>
<script>
import vPartnerComponent from '../../listComponent/basicdata/partner/partnerComponent.vue';
export default {
    name: 'account',
    components: {
        vPartnerComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                sf_code: true,
                province_rid: true,
                city_rid: true,
                updateBtn: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                business_unit_rid:true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>